export default __webpack_public_path__ + "static/careers-hillary-munoz-signature-4844ca2d9ee33111123c915f31beaa57.svg";